import { render } from "./FilterUsers.vue?vue&type=template&id=038c8f62"
import script from "./FilterUsers.vue?vue&type=script&lang=js"
export * from "./FilterUsers.vue?vue&type=script&lang=js"
script.render = render

export default script